import Keycloak from 'keycloak-js'

var keycloak = new Keycloak({
  url: process.env.KEYCLOAK_URL,
  realm: process.env.KEYCLOAK_REALM,
  clientId: process.env.KEYCLOAK_CLIENT_ID
})

export default keycloak



// WEBPACK FOOTER //
// ./src/plugins/keycloak.js